<frontend-size-input [min]="minDuration()" [formControl]="control" [step]="5" [max]="100000000"></frontend-size-input>
